import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import styled from 'styled-components';
import { ClipboardCopy, EmailLink, FormItem, FormText, Input } from 'ui';
// eslint-disable-next-line

const StyledEmaiLink = styled(EmailLink)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

// eslint-disable-next-line
class ContactInfo extends Component {
  render() {
    const {
      mobileNumber,
      phoneNumber,
      email,
    } = this.props.data;
    const {
      isEditable,
      form,
      disabled,
      intl,
    } = this.props;

    const { getFieldDecorator } = form;

    const phoneNumberValidator = getFieldDecorator('phoneNumber', {
      initialValue: phoneNumber,
    });
    const mobileNumberValidator = getFieldDecorator('mobileNumber', {
      initialValue: mobileNumber,
    });
    const emailValidator = getFieldDecorator('email', {
      initialValue: email,
    });

    return (
      <>
        <Row type='flex' gutter={16}>
          <Col md={24} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.EMAIL' })}>
              {isEditable ?
                emailValidator(<Input type='email' disabled={disabled} />)
                :
                <ClipboardCopy onlyCopyThroughIcon={true}>
                  <StyledEmaiLink href={`mailto:${email}`}>{email}</StyledEmaiLink>
                </ClipboardCopy>
              }
            </FormItem>
          </Col>
        </Row>
        <Row type='flex' gutter={16}>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.PHONE_NUMBER' })}>
              {isEditable ?
                phoneNumberValidator(<Input disabled={disabled} />)
                :
                <FormText><ClipboardCopy>{phoneNumber}</ClipboardCopy></FormText>
              }
            </FormItem>
          </Col>
          <Col md={12} sm={24} xs={24}>
            <FormItem label={intl.formatMessage({ id: 'common.labels.MOBILE_NUMBER' })}>
              {isEditable ?
                mobileNumberValidator(<Input disabled={disabled} />)
                :
                <FormText><ClipboardCopy>{mobileNumber}</ClipboardCopy></FormText>
              }
            </FormItem>
          </Col>
        </Row>
      </>
    );
  }
}

ContactInfo.propTypes = {
  data: PropTypes.object,
  isEditable: PropTypes.bool,
  form: PropTypes.object,
  disabled: PropTypes.bool,
  intl: PropTypes.object,
};

export default injectIntl(ContactInfo);
